export const columnsServices:string[] = [
  'Código da OP',
  'Qtd. Materiais',
  'Materiais',
  'Cliente',
  'Etapa atual',
  'Status',
]
export const columnsServices2:string[] = [
  'OP',
  'Item',
  'Pedido',
  'Peso',
  // 'Cod. material',
  'Status',
  // 'Etapas',
  'Etapa atual',
  // 'Tempo',
  'Cliente',
]
export const columnsUsers:string[] = [
  'Nome',
  'Cargo',
  'Custo/hora',
  'Máquinas',
  ''
]

export const columnsMachines:string[] = [
  'Máquina',
  'Modelo',
  'Custo/hora',
  'Última manutenção',
  'Próxima manutenção',
  ''
]

export const columnsReports:string[] = [
  'Ordem de serviço',
  'Operador',
  'Máquina',
  'Tempo de produção ',
  'Status',
  ''
]

// fields

export const fieldsServices:string[] = [
  'id',
  'quantity',
  'material',
  'destination',
  'status'
]

export const fieldsProductionUsers:string[] = [
  'fullName',
  'position',
  'costPerHour',
  'machines',
]

export const fieldsMachines:string[] = [
  'identification',
  'model',
  'costPerHour',
  'lastMaintenance',
  'nextMaintenance'
]

export const fieldsReports:string[] = [
  'id',
  'producerName',
  'machine',
  'productionPace',
  'status'
]